import { Link } from 'wouter';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
      <nav className="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/">
            <a className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-primary-600 to-secondary-500 rounded-lg"></div>
              <span className="text-xl font-bold text-slate-900">dakkio</span>
            </a>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link href="/product">
              <a className="text-slate-600 hover:text-slate-900 font-medium transition-colors">
                Product
              </a>
            </Link>
            <Link href="/pricing">
              <a className="text-slate-600 hover:text-slate-900 font-medium transition-colors">
                Pricing
              </a>
            </Link>
            <Link href="/blog">
              <a className="text-slate-600 hover:text-slate-900 font-medium transition-colors">
                Blog
              </a>
            </Link>
            <a
              href="https://docs.dakkio.io"
              className="text-slate-600 hover:text-slate-900 font-medium transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Docs
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Link href="/signin">
              <a className="text-slate-600 hover:text-slate-900 font-medium transition-colors">
                Sign In
              </a>
            </Link>
            <Link href="/signup">
              <a className="px-4 py-2 bg-primary-600 text-white rounded-lg font-semibold hover:bg-primary-700 transition-colors">
                Get Started
              </a>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-slate-900" />
            ) : (
              <Menu className="w-6 h-6 text-slate-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col space-y-4">
              <Link href="/product">
                <a className="text-slate-600 hover:text-slate-900 font-medium">
                  Product
                </a>
              </Link>
              <Link href="/pricing">
                <a className="text-slate-600 hover:text-slate-900 font-medium">
                  Pricing
                </a>
              </Link>
              <Link href="/blog">
                <a className="text-slate-600 hover:text-slate-900 font-medium">
                  Blog
                </a>
              </Link>
              <a
                href="https://docs.dakkio.io"
                className="text-slate-600 hover:text-slate-900 font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                Docs
              </a>
              <div className="pt-4 border-t border-slate-200 flex flex-col space-y-3">
                <Link href="/signin">
                  <a className="text-center py-2 text-slate-600 hover:text-slate-900 font-medium">
                    Sign In
                  </a>
                </Link>
                <Link href="/signup">
                  <a className="text-center px-4 py-2 bg-primary-600 text-white rounded-lg font-semibold hover:bg-primary-700">
                    Get Started
                  </a>
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
